import { render, staticRenderFns } from "./foreKp.vue?vue&type=template&id=a4b3cd60&scoped=true&"
import script from "./foreKp.vue?vue&type=script&lang=js&"
export * from "./foreKp.vue?vue&type=script&lang=js&"
import style0 from "./foreKp.vue?vue&type=style&index=0&id=a4b3cd60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b3cd60",
  null
  
)

export default component.exports